<template>
    <div>COLLECTIONS REPORT PAGE</div>
</template>